import _Abstract from "system/abstract"

export default class Component_VerticalSlide extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, 
    {
      //scroll_per_pixel_multiplier takes the number of pixels it has scrolled onthe page, and then multiplies it by this
      //So the lower the number the 'slower' it appears, as it is actually closer to matching the speed of the scrolling itself
      scroll_per_pixel_multiplier: 0.08 
    }, options), 'component')

    this.PERENTAGE_OF_ASSET_TO_BE_ON_SCREEN_TO_START = 0; 
 
    this.$window = $(window);
    this.initialise();
  }

  initialise()
  {
      this.setPositionBasedOnScroll();
  }

  isElementOnScreen()
  {
      return this.$el.offset().top < (this.$window.scrollTop() + this.$window.height());
  }

  setPositionBasedOnScroll()
  {
      var bIsElementOnScreen = this.isElementOnScreen();
      if(!bIsElementOnScreen)
      {
          window.requestAnimationFrame(() => this.setPositionBasedOnScroll());
          return;
      }

      this.$el.css("transform","none");
      var pixelsOfElementRequiredOnScreen = (this.$el.height() * (this.PERENTAGE_OF_ASSET_TO_BE_ON_SCREEN_TO_START * 0.001));
      var originalPositionPlusRequiredOnScreen = this.$el.offset().top + pixelsOfElementRequiredOnScreen ;
      var pixelsFromBottomOfScreen = (this.$window.scrollTop() + this.$window.height()) - originalPositionPlusRequiredOnScreen;
      this.$el.css("transform","translate3d(0," + pixelsFromBottomOfScreen*this.options.scroll_per_pixel_multiplier + "rem,0)");
      window.requestAnimationFrame(() => this.setPositionBasedOnScroll());
  }

}



/** WEBPACK FOOTER **
 ** ./components/vertical-slide.js
 **/